import { Grid, Stack } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

import { Direction } from 'theme/enums';

import { SubtitleCard } from './SubtitleCard';
import { ISubtitleCard } from './type';

interface ILayoutConfig {
  useGrid?: boolean;
  responsive?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
}

interface IProps {
  cards: ISubtitleCard[];
  options?: {
    cardSx?: SxProps;
    contentSx?: SxProps;
    layout?: ILayoutConfig;
  };
}

export const SubtitleCards = ({ cards = [], options }: IProps) => {
  const layout = options?.layout;

  if (layout?.useGrid) {
    const responsiveCols = {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 4,
      xl: 4,
      ...(layout.responsive || {}),
    };

    const filteredCards = cards.filter((card) => !card.hide);

    return (
      <Grid container spacing={2} sx={{ margin: '0 -8px !important' }}>
        {filteredCards.map((card) => (
          <Grid
            key={card.label}
            xs={12 / responsiveCols.xs}
            sm={12 / responsiveCols.sm}
            md={12 / responsiveCols.md}
            lg={12 / responsiveCols.lg}
            xl={12 / responsiveCols.xl}
          >
            <SubtitleCard
              {...card}
              options={{
                ...options,
                cardSx: { height: '100%', ...options?.cardSx },
              }}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Stack direction={Direction.ROW} gap={2} flexWrap="wrap">
      {cards.map((card) => (
        <SubtitleCard
          key={card.label}
          {...card}
          options={{
            ...options,
            cardSx: { height: '100%', ...options?.cardSx },
          }}
        />
      ))}
    </Stack>
  );
};
